// extracted by mini-css-extract-plugin
module.exports = {"text":"OpenButton_text__20bgA","contained":"OpenButton_contained__2QrXA","disabled":"OpenButton_disabled__kV6QI","error":"OpenButton_error__OL7VK"};